import { useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';

import * as Styled from './AnonymousBanner.style';

/**
 * Anonymous User Banner Component
 * Displays a promotional banner for anonymous users
 * Encourages account creation to save progress
 *
 * @param {object} props - Component props
 * @param {Function} props.onCreateAccount - Callback when user clicks "Create account" button
 * @param {boolean} [props.dismissible=true] - Whether the banner can be dismissed
 * @returns {object} The AnonymousBanner component
 */
function AnonymousBanner({ onCreateAccount, dismissible = true }) {
  const [dismissed, setDismissed] = useState(false);

  const handleDismiss = () => {
    if (dismissible) {
      setDismissed(true);
    }
  };

  const handleCreateAccount = () => {
    if (onCreateAccount) {
      onCreateAccount();
    }
  };

  // Don't render if dismissed
  if (dismissed) {
    return null;
  }

  return (
    <Styled.BannerRoot role="banner">
      <Styled.BannerText>
        See saved threads and get personalized insights.{' '}
        <Styled.CreateAccountLink component="span" onClick={handleCreateAccount}>
          Create account
        </Styled.CreateAccountLink>
      </Styled.BannerText>

      {dismissible && (
        <Styled.CloseButton label="Dismiss banner" size="small" onClick={handleDismiss}>
          <CloseIcon fontSize="small" />
        </Styled.CloseButton>
      )}
    </Styled.BannerRoot>
  );
}

AnonymousBanner.propTypes = {
  onCreateAccount: PropTypes.func,
  dismissible: PropTypes.bool
};

export default AnonymousBanner;
